import { GlobalHeader } from "../components/organisms/GlobalHeader";

export function AppLayout({ children }) {
  return (
    <>
      <GlobalHeader />
      <main>{children}</main>
    </>
  )
}